/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-analysis-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-analysis-api-client";
import type { StationSettingsClientControllerGetSettingsQueryResponse, StationSettingsClientControllerGetSettingsPathParams } from "../models/StationSettingsClientControllerGetSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { stationSettingsClientControllerGetSettings } from "../axios/stationSettingsClientControllerGetSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const stationSettingsClientControllerGetSettingsQueryKey = (entityId: StationSettingsClientControllerGetSettingsPathParams["entityId"]) => ["video-analysis-api", { url: '/station-settings/:entityId', params: {entityId:entityId} }] as const

export type StationSettingsClientControllerGetSettingsQueryKey = ReturnType<typeof stationSettingsClientControllerGetSettingsQueryKey>

export function stationSettingsClientControllerGetSettingsQueryOptions(entityId: StationSettingsClientControllerGetSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = stationSettingsClientControllerGetSettingsQueryKey(entityId)
  return queryOptions<StationSettingsClientControllerGetSettingsQueryResponse, ResponseErrorConfig<Error>, StationSettingsClientControllerGetSettingsQueryResponse, typeof queryKey>({
   enabled: !!(entityId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return stationSettingsClientControllerGetSettings(entityId, config)
   },
  })
}

/**
 * @description Get settings for a specific station (client access)
 * @summary Get station settings
 * {@link /station-settings/:entityId}
 */
export function useStationSettingsClientControllerGetSettings<TData = StationSettingsClientControllerGetSettingsQueryResponse, TQueryData = StationSettingsClientControllerGetSettingsQueryResponse, TQueryKey extends QueryKey = StationSettingsClientControllerGetSettingsQueryKey>(entityId: StationSettingsClientControllerGetSettingsPathParams["entityId"], options: 
{
  query?: Partial<QueryObserverOptions<StationSettingsClientControllerGetSettingsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? stationSettingsClientControllerGetSettingsQueryKey(entityId)

  const query = useQuery({
   ...stationSettingsClientControllerGetSettingsQueryOptions(entityId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}